import React, {useEffect, useState} from 'react';
import AnalyseA from "./AnalyseA/AnalyseA";
import AdminSection from "./UI/AdminSection";
import Loader from "../Loader";
import _axios from "../../httpService"
import TableView from "./TableView/TableView";
import AnalyseB from "./AnalyseB/AnalyseB";
import TableReport from "./Table/TableReport";
import TableAnipo from "./TableView/TableAnipo";

const AdminReport = () => {
  return (
    <>
      <div style={{
        'padding': '25px',
        'maxHeight': '89vh',
        'overflow': 'scroll',
        // 'background':'red'
      }}>
        <div className={"row"}>
          <div className="col-3">
            <AdminSection height={"auto"}>
              <div className={"d-flex flex-wrap"} style={{
                "overflow": "scroll"
              }}>
                {/*<TableReport part={"part3"}/>*/}
                <AnalyseB part={"part3"} filterType={"type2"} className={"col-2"} BgColor={"#a1c500"} HeaderText={"جدول "}/>
              </div>
            </AdminSection>
          </div>
          <div className={"col-9"}>
            <AdminSection height={"auto"}>
              <AnalyseA part={"part1"} filterType={"type1"} className={"col-4"} BgColor={"#0062ff"}
                        HeaderText={"درصد موفقیت تسک ها"}/>
            </AdminSection>
            <div height={"1vh"}></div>
            <AdminSection height={"auto"} className={"mt-2"}>
              <AnalyseB part={"part2"} filterType={"type2"} className={"col-2"} BgColor={"#a1c500"}
                        HeaderText={"میانگین تاخیر تسک ها"}/>
            </AdminSection>
          </div>

        </div>

        {/**/}
        {/**/}
        {/**/}
        {/**/}
        <br/>
        <br/>
        <br/>
        <br/>
        <div className={"row"}>
          {/*<div className={"col-12"}>*/}
            <AdminSection height={"auto"}>
              <AnalyseB part={"part7"} className={"col-12"} filterType={"type7"} BgColor={"#a1c500"}
                        HeaderText={"گانت چارت مدت زمان تسک ها"}/>
            </AdminSection>
          {/*</div>*/}
        </div>
        <div className={"row"}>
          {/*<div className={"col-12"}>*/}
            <AdminSection height={"auto"}>
              <AnalyseB part={"part8"} className={"col-12"} filterType={"type8"} BgColor={"#a1ccc0"}
                        HeaderText={"گانت چارت مدت زمان فازها"}/>
            </AdminSection>
          {/*</div>*/}
        </div>
        <div className={"row"}>
          <div className={"col-6"}>
            <AdminSection height={"auto"}>
              <AnalyseB part={"part4"} className={"col-6"} filterType={"noFilter"} BgColor={"#a1c500"}
                        HeaderText={"ورکان"}/>
            </AdminSection>
          </div>
          <div className={"col-6"}>
            <AdminSection height={"auto"} className={"mt-2"}>
              <AnalyseB part={"part5"} className={"col-6"} filterType={"noFilter"} BgColor={"#a1c500"}
                        HeaderText={"معتمد آریا "}/>
            </AdminSection>
          </div>
        </div>
        <div className={"row"}>
          <AdminSection height={"auto"} className={"mt-2"}>
            {/*<TableAnipo part={"part6"} />*/}
            <AnalyseB part={"part6"} className={"col-6"} filterType={"noFilter"} BgColor={"#a1c500"}
                      HeaderText={"آنیپو "}/>
          </AdminSection>
        </div>
      </div>
    </>
  );
};

export default AdminReport;
